<div class="header">
    <div class="row main dashboard-title pb-1">
        <div class="col-lg-11 col-md-10 col-xs-10 ">{{ 'overrideCapacity.overrideCapacity' | translate }}</div>
        <div class="col-lg-1 col-md-2 col-xs-1 p-0 icon" mat-dialog-close>
            <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
        </div>
    </div>
</div>
<div class="row current-date mb-4 mt-2 pb-1">
    <div class="col-lg-11 col-md-10 col-xs-10">{{currentDate | date : 'longDate'}}</div>
</div>
<form [formGroup]="overrideForm">
    <div class="d-flex mb-4 flex-column" *ngIf=false>
        <span class="availability-title mb-2">{{ 'overrideCapacity.transportationAvailable' | translate }}</span>
        <div formArrayName="transportOptions" class="d-flex no-gutters flex-wrap transport-checkboxes">
            <div *ngFor="let transport of transportOptionsArr?.controls; let i = index" [formGroupName]="i" class="col-2">
                <mat-checkbox formControlName="isActive" value="transport">{{transport.value.label}}
                </mat-checkbox>
            </div>
        </div>
    </div>
    <div class='sub'>
        <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
        FRH - {{ 'overrideCapacity.flateRateHours' | translate}}
      </div>

    <div class="row slot-override mb-4 mt-2 pb-1">
        <div class="col-lg-11 col-md-10 col-xs-10">{{ 'overrideCapacity.overrideShopFlatrateHours' | translate }}</div>
    </div>

    <table class="alternateColor" aria-describedby="" >
        <th id="header1">
            <tr>
                <div class=" form-control m-2 border-0">{{ 'overrideCapacity.actualShopFRH' | translate }}</div>
            </tr>
        </th>
        <td>
            <div class="form-control m-2 border-0" >{{actualShopHrs}} </div>
        </td>
        <th id="header1">
            <tr>
                <div class=" form-control m-2 border-0">{{ 'overrideCapacity.overrideShopFRH' | translate }}</div>
            </tr>
        </th>
        <td>
                <input type="number" min="0" class="form-control m-2" formControlName='totalShopHrs' />
        </td>
</table>
    <div class="row slot-override mb-4 mt-2 pb-1">
        <div class="col-lg-11 col-md-10 col-xs-10">{{ 'overrideCapacity.overrideTeamFlatrateHours' | translate }}</div>
    </div>
<table class="alternateColor" aria-describedby="" formArrayName="TeamTechnicianHours">
    <th id="header1">
        <tr>
            <div class=" form-control m-2 border-0">{{ 'overrideCapacity.teamName' | translate }}</div>
        </tr>
        <tr *ngFor="let teamHr of teamTechHrsArr?.controls; let i = index" [formGroupName]="i">
            <td>
                <div class=" form-control m-2 border-0">{{teamHr.value.teamName}}</div>
            </td>
        </tr>
    </th>
    <td>
        <tr>
                <div class=" form-control m-2 border-0">{{ 'overrideCapacity.actuallTeamFRH' | translate }}</div>
        </tr>
        <tr *ngFor="let teamHr of teamTechHrsArr?.controls; let i = index" [formGroupName]="i">
            <td >
                <div class=" form-control m-2 border-0">{{teamHr.value.duptotalHrs}}</div>
            </td>
        </tr>
    </td>
    <td>
        <tr>
                <div class=" form-control m-2 border-0">{{ 'overrideCapacity.overrideTeamFRH' | translate }}</div>
        </tr>
        <tr *ngFor="let teamHr of teamTechHrsArr?.controls; let i = index" [formGroupName]="i">
            <td >
                <input type="number" min="0" class="form-control m-2" formControlName="totalHrs" />
            </td>
        </tr>
    </td>
</table>
<div class="controls">
    <div class="cancel enabled" (click)="onCancel()">{{ 'overrideCapacity.cancel' | translate }}</div>
    <div class="save" [ngClass] = "overrideForm.dirty ? 'enabled' : ''" (click)="onSave()">{{ 'overrideCapacity.save' | translate }}</div>
</div>
</form>
